export default "__VITE_ASSET__CBLR6pUi__"